import React, { useState } from 'react'
import { Box, Button, Divider } from '@chakra-ui/core'
import dayjs from 'dayjs'
import { setRemoteCall } from '../../../remote'

const Options = (props) => {
  const { data, relataion, column, setView, setOpen } = props

  //Remove resource from project
  const removeResourceFromProject = (e) => {
    setRemoteCall(
      'unsetRelationToProject',
      {
        _id: relataion,
        date: column.date,
      },
      'Recurso removido com sucesso!'
    )
    setView(null)
    setOpen(false)
  }

  return (
    <>
      {props?.bottom ? (
        <>
          <Button
            className="actionsButton"
            size={'sm'}
            variantColor="red"
            variant="outline"
            onClick={() => setView('changeProjectResource')}
          >
            <i
              className="icons icon-share-alt"
              style={{ marginRight: '4px', fontSize: '1.3em' }}
            />
            Mover para obra
          </Button>
        </>
      ) : props.type === 'project' ? (
        <>
          <Button
            className="actionsButton"
            size={'sm'}
            variantColor="red"
            variant="outline"
            onClick={() => setView('associatePerson')}
          >
            <i
              className="icons icon-link"
              style={{ marginRight: '4px', fontSize: '1.3em' }}
            />
            Associar Pessoa
          </Button>
          <Button
            className="actionsButton"
            size={'sm'}
            variantColor="red"
            variant="outline"
            onClick={() => setView('associateMaterial')}
          >
            <i
              className="icons icon-link"
              style={{ marginRight: '4px', fontSize: '1.3em' }}
            />
            Associar Material
          </Button>
        </>
      ) : (
        <>
          <Button
            className="actionsButton"
            size={'sm'}
            variantColor="red"
            variant="outline"
            onClick={() => setView('changeProject')}
          >
            <i
              className="icons icon-share-alt"
              style={{ marginRight: '4px', fontSize: '1.3em' }}
            />
            Mudar de obra
          </Button>
          <Button
            className="actionsButton"
            size={'sm'}
            variantColor="red"
            variant="outline"
            onClick={() => setView('changeDates')}
          >
            <i
              className="icons icon-event"
              style={{ marginRight: '4px', fontSize: '1.3em' }}
            />
            Editar datas
          </Button>
          {/* <Button
            className="actionsButton"
            size={'sm'}
            variantColor="red"
            variant="outline"
            onClick={() => setView('copyToProject')}
          >
            <i
              className="icons icon-docs"
              style={{ marginRight: '4px', fontSize: '1.3em' }}
            />
            Copiar para obra
          </Button> */}
          <Button
            className="actionsButton"
            size={'sm'}
            variantColor="red"
            variant="outline"
            onClick={() => removeResourceFromProject()}
          >
            <i
              className="icons icon-home"
              style={{ marginRight: '4px', fontSize: '1.3em' }}
            />
            Remover da obra
          </Button>
          {props.type !== 'resorce' ? (
            <Button
              className="actionsButton"
              size={'sm'}
              variantColor="red"
              variant="outline"
              onClick={() => setView('associateMaterial')}
            >
              <i
                className="icons icon-link"
                style={{ marginRight: '4px', fontSize: '1.3em' }}
              />
              Associar Material
            </Button>
          ) : null}
          {/* Add your interactive elements here */}
        </>
      )}
    </>
  )
}

export default Options
